import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DepartmentService } from '../../services/jrni/department.service';
import { AlertService } from '../../_alert';
import { NgxSpinnerService } from 'ngx-spinner';
import { BasketService } from '../../services/jrni/basket.service';
import { TranslateService } from '@ngx-translate/core';
import { DatastoreService } from '../../services/datastore.service';
import { ServicesService } from '../../services/jrni/services.service';
import { AvailabilityService } from '../../services/jrni/availability.service';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { AppConfig } from '../../app.config';
import { ThisReceiver } from '@angular/compiler';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
})
export class ConfirmationComponent implements OnInit {
  selectedDepartment;
  pageTitle: string;
  confirmationPageText: string;
  purchase;
  bookings;
  selectedService;
  selectedLocation;
  address;
  selectedDate;
  selectedSlot;
  client;
  endSlot;
  total;
  extraDetailsPresent;
  bookingSummaryData = [];
  showMap: any;
  confirmationText;
  faChevronRight = faChevronRight;
  faPrint = faPrint;
  public dvlaLookupQuestionMap = AppConfig.settings.dvlaLookupQuestionMap;
  public registration: any = '';
  paidAmount: number;

  constructor(
    private router: Router,
    private departmentService: DepartmentService,
    private alertService: AlertService,
    private spinner: NgxSpinnerService,
    private basketService: BasketService,
    private translateService: TranslateService,
    private servicesService: ServicesService,
    private datastoreService: DatastoreService,
    private availabilityService: AvailabilityService
  ) { }

  restartJourney() {
    this.router.navigate(['/departments']);
  }

  async ngOnInit() {
    this.confirmationText = this.translateService.instant(
      'CONFIRMATION.HEADING_INFO'
    );

    this.showMap = AppConfig.settings.confirmationMap;
    this.scrollToTop();
    this.spinner.show();

    this.paidAmount = this.datastoreService.paidAmount;
    this.selectedDepartment = this.datastoreService.selectedDepartment;
    let parentDepartment = this.datastoreService.parentDepartment;

    if (this.selectedDepartment) {
      this.client = this.datastoreService.customerDetailsForm.value;
      // Get the configurable data
      if (parentDepartment.hasOwnProperty('extra')) {
        // Set the title on the login page to the title from the business question
        parentDepartment.extra.hasOwnProperty('confirmation_page_title')
          ? (this.pageTitle = parentDepartment.extra.confirmation_page_title)
          : (this.pageTitle = 'Confirmation title not set');
        // Set the extra text on the page to the text taken from the business question
        parentDepartment.extra.hasOwnProperty('confirmation_page_text')
          ? (this.confirmationPageText =
            parentDepartment.extra.confirmation_page_text)
          : null;
      }

      // Get the selected service
      this.selectedService = this.datastoreService.selectedService;
      let value = {}
      // for (let control in this.datastoreService.bookingForm.controls) {
      //   value[control] = this.datastoreService.bookingForm.controls[control].value
      // }
      console.log("bookings", this.datastoreService.bookings)

      this.datastoreService.bookingQuestions.forEach((question) => {
        if (value[question['id']]) {
          this.bookingSummaryData.push({
            name: question.name,
            answer: this.datastoreService.bookingAnswers.find((x) => x.id.toString() === question.id.toString()).answer,
            detail_type: question.detail_type,
            price: question.price,
          });
        }
      });
      if (
        this.datastoreService.bookingAnswers.find((x) => x.id.toString() === this.dvlaLookupQuestionMap.regQuestionId.toString())
      ) {
        this.registration = this.datastoreService.bookingAnswers.find((x) => x.id.toString() === this.dvlaLookupQuestionMap.regQuestionId.toString()).answer
      }
      // Check if the questions contain any other purchase details
      const extraDetails = this.bookingSummaryData.filter(
        (elem) => elem.detail_type !== 'check-price'
      );
      extraDetails.length > 0
        ? (this.extraDetailsPresent = true)
        : (this.extraDetailsPresent = false);
      // Calculate purchase total
      const paidItems = this.bookingSummaryData.filter(
        (item) => item.detail_type === 'check-price'
      );
      this.total =
        paidItems.map((items) => items.price).reduce((a, b) => a + b, 0) +
        this.selectedService?.price;

      // Get the selected slot
      // Get the selected slot
      if (!this.datastoreService.selectedSlot) {
        this.selectedSlot = await this.availabilityService.getSelectedSlot()
        this.endSlot = await this.availabilityService.getEndSlot()
      } else{
         this.selectedSlot = this.datastoreService.selectedSlot
         this.endSlot = this.datastoreService.endSlot
      }
      console.log("this.selectedSlot", this.selectedSlot)
      console.log("this.selectedSlot", this.endSlot)
      // this.selectedSlot = this.datastoreService.selectedSlot;
      // Get the selected location
      // Use this.departmentService.getLocation() if the services are set on the children departments
      // Use this.departmentService.get() if the services are set on the parent department
      this.address = this.datastoreService.bookings[0].address;

      // Get the purchase
      this.purchase = this.datastoreService.purchase;
      this.bookings = this.datastoreService.bookings[0];
      console.log(this.purchase)
      console.log(this.bookings)
      this.spinner.hide();
    } else {
      this.restartJourney();
    }
  }

  // print confirmation page
  print() {
    window.print();
  }

  // Start at the top of the page
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }

  goHome() {
    window.location.href =
      'https://www.dorsetcouncil.gov.uk';
  }
}
